<!--
  -  Copyright (c) Qwoach LLC 2023. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 10/10/2023
  -->

<template>
	<div>
		<div
			class="menubar"
		>

			<button
				class="menubar__button"
				:class="{ 'is-active': editor.isActive('bold')}"
				@click="commandWrapper('toggleBold', 'bold')"
			>
				<i class="fontello icon-bold"/>
			</button>

			<button
				class="menubar__button"
				:class="{ 'is-active': editor.isActive('italic') }"
				@click="commandWrapper('toggleItalic', 'Italic')"
			>
				<i class="fontello icon-italic"/>
			</button>

			<button
				class="menubar__button"
				:class="{ 'is-active': editor.isActive('strike') }"
				@click="commandWrapper('toggleStrike', 'Strike')"
			>
				<i class="fontello icon-strike"/>
			</button>

			<button
				class="menubar__button"
				:class="{ 'is-active': editor.isActive('underline') }"
				@click="commandWrapper('toggleUnderline', 'Underline')"
			>
				<i class="fontello icon-underline"/>
			</button>

			<!--				<button-->
			<!--					class="menubar__button"-->
			<!--					:class="{ 'is-active': isActive.code() }"-->
			<!--					@click="commands.code"-->
			<!--				>-->
			<!--					<icon name="code" />-->
			<!--				</button>-->

			<!--				<button-->
			<!--					class="menubar__button"-->
			<!--					:class="{ 'is-active': isActive.paragraph() }"-->
			<!--					@click="commands.paragraph"-->
			<!--				>-->
			<!--					<icon name="paragraph" />-->
			<!--				</button>-->

			<button
				class="menubar__button"
				:class="{ 'is-active': editor.isActive('heading', { level: 1 }) }"
				@click="commandWrapper('toggleHeading', 'Heading 1', { level: 1 })"
			>
				H1
			</button>
			<button
				class="menubar__button"
				:class="{ 'is-active': editor.isActive('heading', { level: 2 }) }"
				@click="commandWrapper('toggleHeading', 'Heading 2', { level: 2 })"
			>
				H2
			</button>
			<button
				class="menubar__button"
				:class="{ 'is-active': editor.isActive('heading', { level: 3 }) }"
				@click="commandWrapper('toggleHeading', 'Heading 3', { level: 3 })"
			>
				H3
			</button>

			<button
				class="menubar__button"
				:class="{ 'is-active': editor.isActive('bulletList') }"
				@click="commandWrapper('toggleBulletList', 'Bullet list')"
			>
				<i class="fontello icon-list-bullet"/>
			</button>

			<button
				class="menubar__button"
				:class="{ 'is-active': editor.isActive('orderedList') }"
				@click="commandWrapper('toggleOrderedList', 'Ordered list')"
			>
				<i class="fontello icon-list-numbered"/>
			</button>

			<button
				class="menubar__button"
				:class="{ 'is-active': editor.isActive('blockquote') }"
				@click="commandWrapper('toggleBlockquote', 'Blockquote')"
			>
				<i class="fontello icon-quote"/>
			</button>

			<button
				class="menubar__button"
				:class="{ 'is-active': editor.isActive('link') }"
				@click="editLinkClicked"
			>
				<i class="fontello icon-link"/>
			</button>
			<button
				class="menubar__button"
				@click="commandWrapper('undo', 'Undo')"
			>
				<i class="fontello icon-ccw"/>
			</button>
			<button
				class="menubar__button"
				@click="commandWrapper('redo', 'Redo')"
			>
				<i class="fontello icon-cw"/>
			</button>

		</div>
	</div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import {Editor} from '@tiptap/vue-3'

export default {
	name: "EditorFixedMenu",
	components: {},
	extends: BaseComponent,

	props: {
		editor: {Editor, required: true},
	},


	methods: {
		commandWrapper(command, commandName, ...args){
			this.$analyticManager.trackEvent(commandName + " clicked", this.analyticsPropsMethod())
			return this.editor.chain().focus()[command](...args).run()//command(...args)
		},

		async editLinkClicked(){
			this.$analyticManager.trackEvent("Link clicked", this.analyticsPropsMethod())
			if(this.editor.isActive('link')){
				this.editor.commands.unsetLink()
			} else {
				this.$emit("linkClicked")
			}
		},
	},
}
</script>

<style lang="scss">

</style>
